import React from 'react';
import { Typography, Stack, Button, useTheme, Divider, TableHead, TableRow, TableCell, TableBody, Box, IconButton } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import route from '../../../utils/Routes';
import BackButton from '../../../components/BackButton';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery, useQueryClient } from 'react-query';
import { formatUserType, isEmpty, isNotEmpty, NumberFormatter } from '../../../utils/format';
import QueryKey from '../../../utils/QueryKey';
import { getSingleProjServ, rmvProjFromUserServ } from '../../../services/proj-service';
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import ScrollBox from '../../../components/ScrollBox';
import BgBoxOld from '../../../components/BgBoxOld';
import LabelTxt from '../../../components/LabelTxt';
import StyledTableContainer from '../../../components/StyledTableContainer';
import AssignProjUser from './AssignProjUser';
import { useState } from 'react';
import { Add, Edit } from '@mui/icons-material';
import EditDeptMdl from '../../ComUser/EditDeptMdl/EditDeptMdl';
import constants from '../../../utils/Constants';



function ProjInfoPage({ type = 'amtc' }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const [searchParams] = useSearchParams();
    const projId = searchParams.get("projId");
    const { setLoadingScreen, setNavComValue, ctxtUser } = useAuthContext();
    const titleTxtSx = { ml: 2, mt: 0.5, fontSize: 13 };

    const { isLoading, isError, error, data: projData } = useQuery([QueryKey.projInfo, projId],
        () => getSingleProjServ(projId),
        {
            enabled: isNotEmpty(projId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });

    const [assUserType, setAssUserType] = useState("")

    const [assMdl, setAssMdl] = useState(false);
    const handleAssMdlClose = () => setAssMdl(false);
    const handleAssMdlOpen = () => setAssMdl(true);

    const [selDept, setSelDept] = useState({})
    const [editDeptMdl, setEditDeptMdl] = useState(false);
    const handleEditDeptMdlClose = () => setEditDeptMdl(false);
    const handleEditDeptMdlOpen = () => setEditDeptMdl(true);

    const inchCols = [
        {
            id: 'empName',
            label: "Employee Name",
            align: 'left',
            minWidth: 150,
        },
        {
            id: 'empId',
            label: "Employee ID",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'username',
            label: "Email ID",
            align: 'left',
            minWidth: 150,
        },
        {
            id: 'role',
            label: "Employee Role",
            align: 'left',
            minWidth: 150
        },
        ...((type === 'amtc' && ctxtUser?.userType === constants.admin) ? [{
            id: 'btn',
            label: "",
            align: 'center',
            minWidth: 100
        }] : [])
    ];

    const deptCols = [
        {
            id: 'deptName',
            label: "Departments",
            align: 'left',
            minWidth: 150,
        },
        {
            id: 'isApproved',
            label: "Approval Status",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'empCount',
            label: "No of Employees",
            align: 'left',
            minWidth: 50
        },
        ...(type === 'com' ? [{
            id: 'btn',
            label: "",
            align: 'center',
            minWidth: 50
        }] : [])
    ];



    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (projData?.comId)
            setNavComValue({ comId: projData?.comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, projData]);



    function handleEditBtnClick() {
        navigate(route.aEditproject, { state: { projId, comId: projData?.comId } });
    };

    function handleAddDeptBtnClick() {
        navigate(route.cDeptCreate, { state: { projId, comId: projData?.comId, actProjIdStrg: projData?.actProjIdStrg } });
    };



    async function handleAssignClick(i) {
        setAssUserType(i?.userType);
        handleAssMdlOpen();
    }



    async function handleRmvClick(i) {
        setLoadingScreen(true);
        try {
            const payload = {
                userId: i?.userId,
                projIdStrg: projId
            }
            const { message } = await rmvProjFromUserServ(payload);
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(`${route.aProjectinfo}/?projId=${projId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    const handleEmpRowClick = (userId) => {
        if (type === "amtc")
            navigate(`${route.aComUserProfile}/?userId=${userId}`);
        else
            navigate(`${route.cUserProfile}/?userId=${userId}`);
    };

    function handleDeptClick(deptId) {
        if (type === "amtc")
            navigate(`${route.aDeptEmpList}/?deptId=${deptId}`);
        else
            navigate(`${route.cDeptEmpList}/?deptId=${deptId}`);
    }

    function handleEditDeptClick(deptData) {
        setSelDept(deptData);
        handleEditDeptMdlOpen()
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <ScrollBox height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", mb: 1 }}>
                <BackButton width={"20%"} />
                <Typography style={{ fontSize: 18, fontWeight: 500 }} >Project Information</Typography>
                <Stack width={"20%"} alignItems={"end"}>
                    {ctxtUser?.userType !== constants.sourcing && (type === "amtc" ? <Button variant='outlined' onClick={handleEditBtnClick} sx={{
                        fontSize: 13, ml: 5,
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30, width: 100
                    }}>
                        Edit Info</Button> : <Button variant='outlined' startIcon={<Add />} onClick={handleAddDeptBtnClick} sx={{
                            fontSize: 13, ml: 5,
                            color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30, width: 200
                        }}>
                        Create Department</Button>)}
                </Stack>

            </Stack>
            <BgBoxOld height={"93%"} py={1} px={1}>
                <Typography sx={{ ml: 2, fontSize: 16, fontWeight: 500, mt: 1, mb: 1 }}>Project Name&emsp;: {projData?.projName}</Typography>
                <Stack direction={"row"} height={80}>
                    <Stack minWidth={370}>
                        <LabelTxt typoname={"Project ID"} typodetail={projData?.actProjIdStrg} overflow={100}
                            namestyle={{ ...titleTxtSx, width: 120 }} detailstyle={{ ...titleTxtSx }} />
                        <LabelTxt typoname={"Approval Limit (OMR)"} typodetail={NumberFormatter(projData?.amtLimit)} overflow={100}
                            namestyle={{ ...titleTxtSx, width: 120 }} detailstyle={{ ...titleTxtSx }} />
                    </Stack>
                    <Divider orientation="vertical" flexItem sx={{ mx: 2, height: "100%" }} />
                    <Stack>
                        <LabelTxt typoname={"Site Location"} typodetail={projData?.siteLocation} overflow={100}
                            namestyle={{ ...titleTxtSx, width: 120 }} detailstyle={{ ...titleTxtSx }} />
                        <LabelTxt typoname={"Dispatch Location"} typodetail={projData?.dispatchLocation} overflow={100}
                            namestyle={{ ...titleTxtSx, width: 120 }} detailstyle={{ ...titleTxtSx }} />
                    </Stack>
                </Stack>
                {projData && <StyledTableContainer height={"23%"} isStickyHeader={true}>
                    <TableHead>
                        <TableRow >
                            {inchCols.map((column) => (
                                <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(projData?.incharge || []).map((i, ind) => {
                            return (
                                <React.Fragment key={`_${ind}`}>
                                    <TableRow hover tabIndex={-1} sx={{ height: 40 }} >
                                        {inchCols.map((column, index) => {
                                            const value = i[column.id];
                                            switch (column.id) {
                                                case "empName":
                                                    return <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {isEmpty(i?.userId) ? "NA" : <Button variant="text" sx={{ color: "black", ml: -1, fontSize: 12 }} onClick={() => handleEmpRowClick(i?.userId)}>
                                                            {value}
                                                        </Button>}
                                                    </TableCell>
                                                case "role":
                                                    return <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {formatUserType(i?.userType)}
                                                    </TableCell>
                                                case "btn":
                                                    return <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {isEmpty(i?.userId) ? <Button variant='outlined' onClick={() => handleAssignClick(i)} sx={{
                                                            fontSize: 13, width: 100, height: 27,
                                                            color: "green", borderColor: "green"
                                                        }}>
                                                            ASSIGN</Button> : <Button variant='outlined' onClick={() => handleRmvClick(i)} sx={{
                                                                fontSize: 13, width: 100, height: 27,
                                                                color: "red", borderColor: "red"
                                                            }}>
                                                            REMOVE</Button>}
                                                    </TableCell>
                                                default:
                                                    return (
                                                        <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                            {(value === null || value === "" || value === "null") ? "NA" : value}
                                                        </TableCell>
                                                    );
                                            }
                                        })}
                                    </TableRow>
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </StyledTableContainer>}
                <Box height={4} />

                {projData && <StyledTableContainer height={"50%"} isStickyHeader={true}>
                    <TableHead>
                        <TableRow >
                            {deptCols.map((column) => (
                                <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{
                                    backgroundColor: "rgba(253, 240, 213, 1)"
                                }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(projData?.depts || []).map((i, ind) => {
                            return (
                                <React.Fragment key={`_${ind}`}>
                                    <TableRow hover tabIndex={-1} sx={{ height: 40 }} >
                                        {deptCols.map((column, index) => {
                                            const value = i[column.id];
                                            switch (column.id) {
                                                case "btn":
                                                    return <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        <IconButton onClick={() => handleEditDeptClick(i)}>
                                                            <Edit sx={{ color: theme.palette.custom.btn }} />
                                                        </IconButton>
                                                    </TableCell>
                                                case "isApproved":
                                                    return <TableCell key={column.id} align={column.align} sx={{
                                                        textAlign: column.align, fontSize: 13,
                                                        color: value === 1 ? "green" : "orange"
                                                    }}>
                                                        {formatUserType(value)}
                                                    </TableCell>
                                                default:
                                                    return (
                                                        <TableCell key={index} align={column.align} onClick={() => handleDeptClick(i?.id)}
                                                            sx={{ textAlign: column.align, fontSize: 13, cursor: "pointer" }}>
                                                            {(value === null || value === "" || value === "null") ? "NA" : value}
                                                        </TableCell>
                                                    );
                                            }
                                        })}
                                    </TableRow>
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </StyledTableContainer>}

            </BgBoxOld>
            {projData && <AssignProjUser modalOpen={assMdl} handleModalClose={handleAssMdlClose} userType={assUserType}
                comId={projData?.comId} projData={projData} />}
            {projData && <EditDeptMdl modalOpen={editDeptMdl} handleModalClose={handleEditDeptMdlClose} deptData={selDept} />}

        </ScrollBox>
    );
}
export default ProjInfoPage;